// extracted by mini-css-extract-plugin
module.exports = {"btfcontent":"GyxUr","listing_v2":"kNYLq","text":"_IxC1","column":"HXYKN","coloured":"u95o5","disclamer":"MnS5U"};